export const extraLarge = '@media (min-width: 1201px)'
export const large = '@media (min-width: 1200px)'
export const medium = '@media (min-width: 990px)'
export const small = '@media (max-width: 991px)'
